export const generateSrcFromEmail = (email?: string, bgColor?: string) => {
  return generate(email ?? 'mimir.operator@runelab.it', bgColor)
}

const generate = (email: string, bgColor?: string) => {
  const myNames = email.split('@')?.shift()?.split('.')
  const initials = myNames?.shift()?.charAt(0) + (myNames?.pop()?.charAt(0) || '')
  const nameInitials = initials.toUpperCase()
  const bcgColor = bgColor || generateHexColor(email)
  const textColor = getContrastYIQ(bcgColor)
  return generateAvatar(nameInitials, textColor, bcgColor)
}
const generateHexColor = (email: string) => {
  let hash = 0
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash)
  }

  const color = (hash & 0x00ffffff).toString(16).toUpperCase()
  return '#' + '00000'.substring(0, 6 - color.length) + color
}
const getContrastYIQ = (hexColor: string) => {
  const r = parseInt(hexColor.substr(0, 2), 16)
  const g = parseInt(hexColor.substr(2, 2), 16)
  const b = parseInt(hexColor.substr(4, 2), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'black' : 'white'
}
const generateAvatar = (text: string, foregroundColor: string, backgroundColor: string) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  if (!context) return ''

  canvas.width = 200
  canvas.height = 200

  // Draw background
  context.fillStyle = backgroundColor
  context.fillRect(0, 0, canvas.width, canvas.height)

  // Draw text
  context.font = 'bold 100px Arial'
  context.fillStyle = foregroundColor
  context.textAlign = 'center'
  context.textBaseline = 'middle'
  context.fillText(text, canvas.width / 2, (canvas.height + 12) / 2)
  return canvas.toDataURL('image/png')
}
